import React from 'react';
import Organiser from '../../EventInfo/OrganizerDetails/OrganiserInfo/OrganiserInfo';
import '.././manageEvents.css';
import { useLocation } from "react-router-dom";

const OrganiserDetails = (props) => {
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const profileId = pathParts[2];

    return (
        <div className='manage_events_container p-4'>
            <p className='heading'>Organizer Details</p>
            <Organiser {...props} module="event-profile" profileId={profileId} />
        </div>
    )
}

export default OrganiserDetails